<mat-toolbar class="topbar mat-bg-card">
  <!-- Sidenav toggle button -->
  <button *ngIf="layoutConf.sidebarStyle !== 'compact'" mat-icon-button id="sidenavToggle" (click)="toggleSidenav()"
    matTooltip="Toggle Hide/Open">
    <mat-icon>menu</mat-icon>
  </button>

  <!-- App search -->
  <!-- <sca-app-search></sca-app-search> -->

  <!-- Online Help Link -->
  <!-- <a href="http://sab.is/DBY6RZ" target="_blank" class="help-link" matTooltip="Online Help">
    <span class="material-symbols-outlined">
      help
    </span>
  </a> -->
  <span class="splitter"></span>

  <!-- Notification toggle button -->
  <button mat-icon-button matTooltip="Notifications" (click)="toggleNotific()" [style.overflow]="'visible'"
    *ngIf="false" class="topbar-button-right">
    <mat-icon>notifications</mat-icon>
    <span class="notification-number mat-bg-warn">3</span>
  </button>

  <span *ngIf="username" class="username">{{ username }}</span>

  <!-- Top left user menu -->
  <button class="user-button" [matMenuTriggerFor]="accountMenu">
    <!--<img src="assets/images/face-7.jpg" alt="" />-->
    <span class="profile-initials">
      <mat-icon>person</mat-icon>
      {{ initials }}
    </span>

  </button>

  <mat-menu #accountMenu="matMenu">
    <button *ngIf="false" mat-menu-item [routerLink]="['/profile/overview']">
      <mat-icon>account_box</mat-icon>
      <span>Profile</span>
    </button>

    <button *ngIf="false" mat-menu-item [routerLink]="['/profile/settings']">
      <mat-icon>settings</mat-icon>
      <span>Account Settings</span>
    </button>

    <button *ngIf="false" mat-menu-item>
      <mat-icon>notifications_off</mat-icon>
      <span>Disable alerts</span>
    </button>

    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Sign out</span>
    </button>

  </mat-menu>
</mat-toolbar>
